import { Timestamp, addDoc, collection } from "firebase/firestore";
import { useContext, useState } from "react";
import myContext from "../../../Context/myContext";
import toast from "react-hot-toast";
import { fireDB, storage } from "../../../firebase/FirebaseConfig";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router";
import Loader from "../../loader/Loader";
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap

const categoryList = [
  { name: 'CategoryList' },
  { name: 'printer' },
  { name: 'spareparts' },
  { name: 'machine' },
  { name: 'fluids' }
  
];

const AddProductPage = () => {
  const context = useContext(myContext);
  const { loading, setLoading } = context;
  const navigate = useNavigate();

  // Product state
  const [product, setProduct] = useState({
    title: "",
    price: "",
    category: "",
    description: "",
    quantity: 1,
    time: Timestamp.now(),
    date: new Date().toISOString().slice(0, 10) // Simplified date formatting
  });

  // Image state
  const [imageFile, setImageFile] = useState(null);

  // Handle image upload
  const handleImageUpload = (e) => {
    setImageFile(e.target.files[0]);
  };

  // Add Product Function
  const addProductFunction = async () => {
    // Validate the inputs
    if (!product.title || !product.price || !product.category || !product.description || !imageFile) {
      return toast.error("All fields are required");
    }

    setLoading(true);

    try {
      // Upload the image to Firebase storage
      const storageRef = ref(storage, `products/${Date.now()}_${imageFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, imageFile);

      // Track upload progress and handle success or errors
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
        },
        async (error) => {
          console.error("Image upload failed:", error);
          toast.error("Image upload failed");
          setLoading(false);
        },
        async () => {
          // Get the download URL after successful upload
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          const productRef = collection(fireDB, "products");

          // Add the product with the image URL to Firestore
          await addDoc(productRef, {
            ...product,
            productImageUrl: downloadURL
          });

          // Show success message and reset the form
          toast.success("Product listed successfully");

          // Clear form fields after adding the product
          setProduct({
            title: "",
            price: "",
            category: "",
            description: "",
            quantity: 1,
            time: Timestamp.now(),
            date: new Date().toISOString().slice(0, 10)
          });
          setImageFile(null); // Reset the image file
          setLoading(false);
          navigate("/admin-dashboard");
        }
      );
    } catch (error) {
      console.error("Failed to add product:", error);
      setLoading(false);
      toast.error("Failed to add product");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      {loading && <Loader />}
      <div className="card p-4 shadow-sm" style={{ maxWidth: '500px', width: '100%' }}>
        <h2 className="text-center text-primary mb-4">Add Product</h2>

        {/* Product Title */}
        <div className="mb-3">
          <input
            type="text"
            name="title"
            value={product.title}
            onChange={(e) => setProduct({ ...product, title: e.target.value })}
            placeholder="Product Title"
            className="form-control"
          />
        </div>

        {/* Product Short Description */}
        <div className="mb-3">
          <input
            type="text"
            name="product short description"
            value={product.price}
            onChange={(e) => setProduct({ ...product, price: e.target.value })}
            placeholder="Product Short Description"
            className="form-control"
          />
        </div>

        {/* Image Upload */}
        <div className="mb-3">
          <label className="form-label">Product Image</label>
          <input
            type="file"
            name="productImage"
            onChange={handleImageUpload}
            className="form-control"
            accept="image/*" // Restrict file types to images only
          />
        </div>

        {/* Product Category */}
        <div className="mb-3">
          <select
            value={product.category}
            onChange={(e) => setProduct({ ...product, category: e.target.value })}
            className="form-select"
          >
            <option disabled>Select Product Category</option>
            {categoryList.map((value, index) => (
              <option key={index} value={value.name}>
                {value.name.charAt(0).toUpperCase() + value.name.slice(1)}
              </option>
            ))}
          </select>
        </div>

        {/* Product Description */}
        <div className="mb-3">
          <textarea
            value={product.description}
            onChange={(e) => setProduct({ ...product, description: e.target.value })}
            name="description"
            placeholder="Product Description"
            rows="4"
            className="form-control"
          />
        </div>

        {/* Add Product Button */}
        <button
          onClick={addProductFunction}
          type="button"
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? "Adding Product..." : "Add Product"}
        </button>
      </div>
    </div>
  );
};

export default AddProductPage;